import React from 'react';
import { observer } from 'mobx-react';

import DoneAllIcon from '@mui/icons-material/DoneAll';

import { StyledTextField } from 'components/Input/styles';
import SearchAdornment from 'components/Adornment/SearchAdornment';

import { useStore } from 'utils/hooks/store';

import { ToolbarContainer, LeftSection, StyledTabs, StyledTab, MarkAllReadButton, SearchInput } from './styles';

const KnockNotificationsToolbar: React.FunctionComponent = (): React.ReactElement => {
  const {
    dualInbox: {
      showUnreadOnly,
      setShowUnreadOnly,
      unreadFilteredCount,
      isDismissing,
      dismissNotifications,
      searchQuery,
      setSearchQuery,
    },
  } = useStore();

  const debounceRef = React.useRef<ReturnType<typeof setTimeout>>();
  const [localSearch, setLocalSearch] = React.useState(searchQuery);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value;
    setLocalSearch(value);
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      setSearchQuery(value);
    }, 300);
  };

  React.useEffect(
    () => () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
      setSearchQuery('');
    },
    []
  );

  React.useEffect(() => {
    setLocalSearch(searchQuery);
  }, [searchQuery]);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number): void => {
    setShowUnreadOnly(newValue === 1);
  };

  return (
    <ToolbarContainer>
      <LeftSection>
        <StyledTabs value={showUnreadOnly ? 1 : 0} onChange={handleTabChange}>
          <StyledTab label="All" />
          <StyledTab label={`Unread (${unreadFilteredCount})`} />
        </StyledTabs>
        <MarkAllReadButton
          onClick={dismissNotifications}
          disabled={isDismissing || unreadFilteredCount === 0}
          type="button"
        >
          <DoneAllIcon fontSize="small" />
          Mark all read
        </MarkAllReadButton>
      </LeftSection>
      <SearchInput>
        <StyledTextField
          size="small"
          placeholder="Search notifications"
          value={localSearch}
          onChange={handleSearchChange}
          fullWidth
          slotProps={{
            input: {
              startAdornment: <SearchAdornment fontSize="small" />,
            },
          }}
        />
      </SearchInput>
    </ToolbarContainer>
  );
};

export default observer(KnockNotificationsToolbar);
